export interface ShellNavItem {
  label: string;
  icon: string;
  routerLink: string;
  visible: boolean;
  urlPrefixes?: string[];
}

export function navItemMatchesUrl(item: ShellNavItem, url: string): boolean {
  const path = url.split(/[?#]/, 1)[0];
  if (path === item.routerLink || path.startsWith(`${item.routerLink}/`)) {
    return true;
  }
  return (item.urlPrefixes ?? []).some(
    (prefix) => path === prefix || path.startsWith(prefix),
  );
}
